import { ReactNode } from 'react';
import { QuoteTransactionStatus } from 'src/redux/types/quoteSlice';

export const iconByTransactionStatus: Record<QuoteTransactionStatus, ReactNode> = {
	PENDING: '⚪️',
	MISSING_ADDRESS: '🟡',
	SUBMITTED: '🟢',
	ERROR: '🔴',
};
